export default (barcode = '') => {
    if (!barcode || typeof barcode !== 'string') {
        throw new Error('Vui lòng nhập lại barcode.')
    }

    const vBarcode = barcode.trim()
    const regex = /^#?(\d+)_(\d+)$/

    const parsed = regex.exec(vBarcode)
    if (!parsed || parsed.length !== 3) {
        throw new Error('Barcode nhập không đúng.')
    }

    const [_barcode, number, index] = parsed

    return {
        barcode: _barcode,
        number: parseInt(number, 10),
        index: parseInt(index, 10),
        code: vBarcode,
    }
}

